// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./assets/styles/fonts.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* IMPORT CUSTOM FONT */

@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  html {
    /* font-family: 'Inter', sans-serif; */
    font-family: 'Monaco';
  }
}

:root {
  --custom-font-size: 16px !important;
  --custom-font-family: 'Monaco';
}

body {
  background-color: #000;
}

/* Truncate 2 lines utility */
.truncate-2-lines {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.3;
  height: 2.1rem;
}

/* disabled class - used for icons and divs based on context */
.ohif-disabled {
  pointer-events: none;
  cursor: not-allowed;
  user-select: none;
  opacity: 0.5;
}

@layer base {
  :root {
    --highlight: 191 74% 63%;
    --neutral: 213 22% 59%;
    --background: 236 62% 5%;
    --foreground: 0 0% 98%;
    --card: 236 62% 5%;
    --card-foreground: 0 0% 98%;
    --popover: 219 90% 15%;
    --popover-foreground: 0 0% 98%;
    --primary: 214 98% 60%;
    --primary-foreground: 0 0% 98%;
    --secondary: 214 66% 48%;
    --secondary-foreground: 200 50% 84%;
    --muted: 234 64% 10%;
    --muted-foreground: 200 46% 65%;
    --accent: 217 79% 24%;
    --accent-foreground: 0 0% 98%;
    --destructive: 0 62.8% 30.6%;
    --destructive-foreground: 0 0% 98%;
    --border: 0 0% 14.9%;
    --input: 236 52% 30%;
    --ring: 214 98% 60%;
    --chart-1: 220 70% 50%;
    --chart-2: 160 60% 45%;
    --chart-3: 30 80% 55%;
    --chart-4: 280 65% 60%;
    --chart-5: 340 75% 55%;
    --radius: 0.5rem;
    --success-bg: hsl(143, 85%, 96%);
    --success-border: hsl(145, 92%, 91%);
    --success-text: hsl(140, 100%, 27%);

    --info-bg: hsl(208, 100%, 97%);
    --info-border: hsl(221, 91%, 91%);
    --info-text: hsl(210, 92%, 45%);

    --warning-bg: hsl(49, 100%, 97%);
    --warning-border: hsl(49, 91%, 91%);
    --warning-text: hsl(31, 92%, 45%);

    --error-bg: hsl(359, 100%, 97%);
    --error-border: hsl(359, 100%, 94%);
    --error-text: hsl(360, 100%, 45%);
  }

  .dark {
    --background: 0 0% 3.9%;
    --foreground: 0 0% 98%;
    --card: 0 0% 3.9%;
    --card-foreground: 0 0% 98%;
    --popover: 0 0% 3.9%;
    --popover-foreground: 0 0% 98%;
    --primary: 214 98% 60%;
    --primary-foreground: 0 0% 98%;
    --secondary: 0 0% 14.9%;
    --secondary-foreground: 0 0% 98%;
    --muted: 0 0% 14.9%;
    --muted-foreground: 0 0% 63.9%;
    --accent: 0 0% 14.9%;
    --accent-foreground: 0 0% 98%;
    --destructive: 0 62.8% 30.6%;
    --destructive-foreground: 0 0% 98%;
    --border: 0 0% 14.9%;
    --input: 236 52% 30%;
    --ring: 214 98% 60%;
    --chart-1: 220 70% 50%;
    --chart-2: 160 60% 45%;
    --chart-3: 30 80% 55%;
    --chart-4: 280 65% 60%;
    --chart-5: 340 75% 55%;
  }
}
`, "",{"version":3,"sources":["webpack://./../../ui/src/tailwind.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAGvB,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;AAEnB;EACE;IACE,sCAAsC;IACtC,qBAAqB;EACvB;AACF;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA,8DAA8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE;IACE,wBAAwB;IACxB,sBAAsB;IACtB,wBAAwB;IACxB,sBAAsB;IACtB,kBAAkB;IAClB,2BAA2B;IAC3B,sBAAsB;IACtB,8BAA8B;IAC9B,sBAAsB;IACtB,8BAA8B;IAC9B,wBAAwB;IACxB,mCAAmC;IACnC,oBAAoB;IACpB,+BAA+B;IAC/B,qBAAqB;IACrB,6BAA6B;IAC7B,4BAA4B;IAC5B,kCAAkC;IAClC,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,gBAAgB;IAChB,gCAAgC;IAChC,oCAAoC;IACpC,mCAAmC;;IAEnC,8BAA8B;IAC9B,iCAAiC;IACjC,+BAA+B;;IAE/B,gCAAgC;IAChC,mCAAmC;IACnC,iCAAiC;;IAEjC,+BAA+B;IAC/B,mCAAmC;IACnC,iCAAiC;EACnC;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,2BAA2B;IAC3B,oBAAoB;IACpB,8BAA8B;IAC9B,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,gCAAgC;IAChC,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;IACpB,6BAA6B;IAC7B,4BAA4B;IAC5B,kCAAkC;IAClC,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;EACxB;AACF","sourcesContent":["/* IMPORT CUSTOM FONT */\r\n@import './assets/styles/fonts.css';\r\n\r\n@tailwind base;\r\n@tailwind components;\r\n@tailwind utilities;\r\n\r\n@layer base {\r\n  html {\r\n    /* font-family: 'Inter', sans-serif; */\r\n    font-family: 'Monaco';\r\n  }\r\n}\r\n\r\n:root {\r\n  --custom-font-size: 16px !important;\r\n  --custom-font-family: 'Monaco';\r\n}\r\n\r\nbody {\r\n  background-color: #000;\r\n}\r\n\r\n/* Truncate 2 lines utility */\r\n.truncate-2-lines {\r\n  overflow: hidden;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  line-height: 1.3;\r\n  height: 2.1rem;\r\n}\r\n\r\n/* disabled class - used for icons and divs based on context */\r\n.ohif-disabled {\r\n  pointer-events: none;\r\n  cursor: not-allowed;\r\n  user-select: none;\r\n  opacity: 0.5;\r\n}\r\n\r\n@layer base {\r\n  :root {\r\n    --highlight: 191 74% 63%;\r\n    --neutral: 213 22% 59%;\r\n    --background: 236 62% 5%;\r\n    --foreground: 0 0% 98%;\r\n    --card: 236 62% 5%;\r\n    --card-foreground: 0 0% 98%;\r\n    --popover: 219 90% 15%;\r\n    --popover-foreground: 0 0% 98%;\r\n    --primary: 214 98% 60%;\r\n    --primary-foreground: 0 0% 98%;\r\n    --secondary: 214 66% 48%;\r\n    --secondary-foreground: 200 50% 84%;\r\n    --muted: 234 64% 10%;\r\n    --muted-foreground: 200 46% 65%;\r\n    --accent: 217 79% 24%;\r\n    --accent-foreground: 0 0% 98%;\r\n    --destructive: 0 62.8% 30.6%;\r\n    --destructive-foreground: 0 0% 98%;\r\n    --border: 0 0% 14.9%;\r\n    --input: 236 52% 30%;\r\n    --ring: 214 98% 60%;\r\n    --chart-1: 220 70% 50%;\r\n    --chart-2: 160 60% 45%;\r\n    --chart-3: 30 80% 55%;\r\n    --chart-4: 280 65% 60%;\r\n    --chart-5: 340 75% 55%;\r\n    --radius: 0.5rem;\r\n    --success-bg: hsl(143, 85%, 96%);\r\n    --success-border: hsl(145, 92%, 91%);\r\n    --success-text: hsl(140, 100%, 27%);\r\n\r\n    --info-bg: hsl(208, 100%, 97%);\r\n    --info-border: hsl(221, 91%, 91%);\r\n    --info-text: hsl(210, 92%, 45%);\r\n\r\n    --warning-bg: hsl(49, 100%, 97%);\r\n    --warning-border: hsl(49, 91%, 91%);\r\n    --warning-text: hsl(31, 92%, 45%);\r\n\r\n    --error-bg: hsl(359, 100%, 97%);\r\n    --error-border: hsl(359, 100%, 94%);\r\n    --error-text: hsl(360, 100%, 45%);\r\n  }\r\n\r\n  .dark {\r\n    --background: 0 0% 3.9%;\r\n    --foreground: 0 0% 98%;\r\n    --card: 0 0% 3.9%;\r\n    --card-foreground: 0 0% 98%;\r\n    --popover: 0 0% 3.9%;\r\n    --popover-foreground: 0 0% 98%;\r\n    --primary: 214 98% 60%;\r\n    --primary-foreground: 0 0% 98%;\r\n    --secondary: 0 0% 14.9%;\r\n    --secondary-foreground: 0 0% 98%;\r\n    --muted: 0 0% 14.9%;\r\n    --muted-foreground: 0 0% 63.9%;\r\n    --accent: 0 0% 14.9%;\r\n    --accent-foreground: 0 0% 98%;\r\n    --destructive: 0 62.8% 30.6%;\r\n    --destructive-foreground: 0 0% 98%;\r\n    --border: 0 0% 14.9%;\r\n    --input: 236 52% 30%;\r\n    --ring: 214 98% 60%;\r\n    --chart-1: 220 70% 50%;\r\n    --chart-2: 160 60% 45%;\r\n    --chart-3: 30 80% 55%;\r\n    --chart-4: 280 65% 60%;\r\n    --chart-5: 340 75% 55%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
